import { BASE_URL } from "@src/utils";
import { MyWeddingContractInfo } from "@src/types/weddingHall";
import axios from "../axios";
import { ServerResponse, ServerResponseResult } from "../axios";

export const getContractInfo = (contractUuid: string) => {
  const url = `${BASE_URL}/v3/book/20240729/halls/weddings/contracts/${contractUuid}`;

  return axios.get<{ item: MyWeddingContractInfo }>(url);
};

// 푸시설정 가져오기
export const getPushSetting = () => {
  const url = `${BASE_URL}/v4/20241113/pushsetting`;
  return axios.get<
    ServerResponse<{
      allAgree: 0 | 1;
      community: 0 | 1;
      content: 0 | 1;
      event: 0 | 1;
      best: 0 | 1;
      communityNight: 0 | 1;
      chat: 0 | 1;
    }>
  >(url);
};

// 푸시설정 변경
export const putPushSetting = (params: {
  allAgree?: 0 | 1;
  community?: 0 | 1;
  content?: 0 | 1;
  event?: 0 | 1;
  best?: 0 | 1;
  communityNight?: 0 | 1;
  chat?: 0 | 1;
}) => {
  const url = `${BASE_URL}/v4/20241113/pushsetting`;
  return axios.put<ServerResponseResult>(url, params);
};

// 마케팅 수신동의 상태 변경
export const putMarketingAgree = (params: { state: 1 | 0; inPath: "MYPAGE" }) => {
  const url = `${BASE_URL}/v4/20241113/customer/terms/MARKETING`;
  return axios.put<ServerResponseResult>(url, params);
};

export const getUnreadChatInfo = () => {
  return axios.get<any>(`${BASE_URL}/v3/mypage/total-push-chat`);
};

// 계약서 PDF 다운로드
export const downloadContractPdf = async (contractUuid: string) => {
  const res = await axios.get<Blob>(`${BASE_URL}/v4/20240729/hall/contract/${contractUuid}/pdf`, {
    responseType: "blob",
  });

  const blob = new Blob([res.data], { type: "application/pdf" });

  // Content-Disposition 헤더에서 파일명 추출
  const disposition = res.headers["content-disposition"];
  let filename = "예식계약서.pdf";
  if (disposition) {
    const match = disposition.match(/filename\*=UTF-8''(.+)/);
    if (match) {
      filename = decodeURIComponent(match[1]);
    }
  }

  const downloadFile = () => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // 모바일 공유 API 지원 시 공유, 실패하면 다운로드 fallback
  const file = new File([blob], filename, { type: "application/pdf" });
  if (navigator.share && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: filename });
    } catch (e) {
      if (e instanceof DOMException && e.name === "AbortError") return;
      downloadFile();
    }
  } else {
    downloadFile();
  }
};
